// import { createFilter, dataToEsm } from '@rollup/pluginutils';
import dataToEsm from '../pluginutils/dataToEsm';

export default function json(options = {}) {
  // const filter = createFilter(options.include, options.exclude);
  const indent = 'indent' in options ? options.indent : '\t';

  return {
    name: 'json',

    // eslint-disable-next-line no-shadow
    transform(code, id) {
      // if (id.slice(-5) !== '.json' || !filter(id)) return null;
      if (id.slice(-5) !== '.json') return null;

      try {
        const parsed = JSON.parse(code);
        return {
          code: dataToEsm(parsed, {
            preferConst: options.preferConst,
            compact: options.compact,
            namedExports: options.namedExports,
            includeArbitraryNames: options.includeArbitraryNames,
            indent,
          }),
          map: { mappings: '' },
        };
      } catch (err) {
        const message = 'Could not parse JSON file';
        this.error({ message, id, cause: err });
        return null;
      }
    },
  };
}
